import settings from "@settings";

export const contentContainer = settings.mq({
    position: 'relative',
    width: '100%',
    height: 'auto',
    overflow: 'auto',
    backgroundColor: settings.colors.white,
    padding: settings.padding.medium,
    paddingTop: '120px',
    paddingBottom: '60px'
})